export default __webpack_public_path__ + "static/media/jordan_3.691e3f22.png";